import { useEffect } from "react";
import InitialAccountData from "../InitialAccountData/InitialAccountData";
import SetStaffPermissionsPage from "../../pages/SetStaffPermissionsPage/SetStaffPermissionsPage";
import PersonaAccountRegistrationPage from "../PersonaAccountRegistrationPage/PersonaAccountRegistrationPage";
import PurchaseSubscriptionsPage from "../../pages/PurchaseSubscriptionsPage/PurchaseSubscriptionsPage"
import ProgressBar from "../ProgressBar/ProgressBar";
import { useParams } from "react-router-dom";
import { APIProvider } from "../../utilities/Contexts/DCGAutomationPagesContextProvider";
import SubscriptionConfirmation from "../../pages/SubscriptionConfirmation/SubscriptionConfirmation";
import useOnboardingNavigation from "../../hooks/useOnboardingNavigation";

// This is the entry point of the OLD onboarding flow, pre-DCG-Automation
const NewAccountPage = () => {
    const params = useParams();
    const parsedFormId = parseInt(params.formId);
    const currentPageNumber = isNaN(parsedFormId) ? 1 : parsedFormId;
    const numberOfPages = 5;
    const { setPage, nextPage, prevPage } = useOnboardingNavigation(currentPageNumber, numberOfPages);

    // Sequence of pages for the old onboarding flow (pre-DCG-Automation)
    const onboardingPages = [
        null, // index 0 placeholder
        { page: () => <InitialAccountData submitHandler={nextPage} /> },
        { page: () => <SetStaffPermissionsPage submitHandler={nextPage} prevPage={prevPage} /> },
        { page: () => <PersonaAccountRegistrationPage submitHandler={nextPage} prevPage={prevPage} /> },
        { page: () => <PurchaseSubscriptionsPage prevPage={prevPage} /> },
        { page: () => <SubscriptionConfirmation />,
            finalConfirmation: true }
    ];

    // Intercept back button on browser, call prevPage() function instead
    useEffect(() => {
        const handler = (event) => {
            event.preventDefault();
            prevPage();
        };
        window.onpopstate = handler;
    
        return () => {
            window.onpopstate = null;
        };
    }, [prevPage]);

    useEffect(() => {
        setPage(!isNaN(currentPageNumber) ? currentPageNumber : 1);
    }, [currentPageNumber, setPage]);

    return (
        <APIProvider currentPage={onboardingPages[currentPageNumber]}>
            <div className="container">
                <div className="d-flex justify-content-center my-3" >
                    <ProgressBar currentStep={currentPageNumber} length={numberOfPages}></ProgressBar>
                </div>
                
                {/* Render current page */}
                {onboardingPages[currentPageNumber].page()}

            </div>
        </APIProvider>
    )
}

export default NewAccountPage;